/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacAquarius = createReactComponent("zodiac-aquarius", "IconZodiacAquarius", [
  ["path", { d: "M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3", key: "svg-0" }],
  ["path", { d: "M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3", key: "svg-1" }]
]);

export { IconZodiacAquarius as default };
//# sourceMappingURL=IconZodiacAquarius.js.map
